<!-- Refund Items Display -->
@if (refund && refund.refundItems && refund.refundItems.length > 0) {
  <div class="refund-breakdown">
    <h6 class="breakdown-title">Stavke povrata</h6>
    <!-- Unified Card Grid Layout -->
    <div class="refund-items-grid">
      @for (item of refund.refundItems; track item) {
        <div class="refund-item-card">
          <mat-card class="mat-elevation-2">
            <mat-card-content>
              <div class="item-header">
                <h6 class="item-description">{{ item.description }}</h6>
              </div>
              <div class="amounts-container">
                <div class="amount-row">
                  <div class="amount-box contracted">
                    <span class="amount-label">Ugovoreno</span>
                    <span class="amount-value">{{ item.contractedAmount | currency:'EUR' }}</span>
                  </div>
                  <div class="amount-box realized">
                    <span class="amount-label">Realizirano</span>
                    <span class="amount-value">{{ item.realizedAmount | currency:'EUR' }}</span>
                  </div>
                </div>
                <div class="refund-row">
                  <div class="refund-box">
                    <mat-icon class="refund-icon">undo</mat-icon>
                    <div class="refund-content">
                      <span class="refund-label">Povrat</span>
                      <span class="refund-value">{{ item.refundAmount | currency:'EUR' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
    <!-- Total Refund Amount -->
    <div class="total-refund-summary">
      <mat-card class="total-card mat-elevation-4">
        <mat-card-content>
          <div class="total-content">
            <mat-icon class="total-icon">account_balance_wallet</mat-icon>
            <div class="total-text">
              <span class="total-label">Ukupan povrat sredstava</span>
              <span class="total-amount">{{ getTotalRefundAmount() | currency:'EUR' }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
}

<!-- No Refund Items -->
@if (refund && (!refund.refundItems || refund.refundItems.length === 0)) {
  <div class="no-refund-items">
    <mat-chip-set>
      <mat-chip>
        <mat-icon>info</mat-icon>
        Nema stavki za povrat
      </mat-chip>
    </mat-chip-set>
  </div>
}
